module.exports = __webpack_public_path__ + "static/media/Completion_Check.0af24d05.svg";